/**
 * 土耳其语
 */
var trTR = {
  locale: 'tr-TR',
  Common: {
    pleaseInput: 'Lütfen giriniz',
    pleaseSelect: 'Lütfen seçiniz',
    confirm: 'Onayla',
    clear: 'Temizle',
    cancel: 'İptal',
    next: 'İleri',
    previous: 'Geri',
    submit: 'Gönder',
    reset: 'Sıfırla'
  },
  Exception: {
    emptyData: 'Veri yok',
    error: 'Sayfa hatası. Daha sonra tekrar deneyin',
    networkError: 'Ağ hatası'
  },
  List: {
    noMoreData: 'Daha fazla veri yok',
    networkError: 'Ağ hatası',
    clickRetry: 'Tekrar dene'
  },
  DateRangePicker: {
    startTime: 'Başlangıç zamanı',
    endTime: 'Bitiş zamanı',
    timeRange: 'Zaman aralığı'
  }
};

export { trTR as default };
